import PropTypes from "prop-types"
import { Backdrop, Box, Button, ButtonGroup, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material"
import Map from "./map"
import StreetView from "./streetview"
import React, { useCallback, useContext, useRef, useState } from "react"
import Datatable from "./datatable"
import { Boy as BoyIcon, Map as MapIcon } from "@mui/icons-material"
import UseApiManager from "../../../../../../manager/api"
import { RootDataContext } from "../../../.."
import { RefreshTree } from "../../../../../../manager/carto"

const MapMode = {
  Map: "map",
  StreetView: "street_view",
}

const styles = {
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    overflowY: "hidden",
    gap: 0,
    position: "relative",
  },
  leftColumn: {
    width: "400px",
    flex: "0 0 400px",
    overflowY: "auto",
    minHeight: 0,
    boxSizing: "border-box",
  },
  rightColumn: {
    flex: 1,
    minWidth: 0,
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },
  mapModeBox: {
    position: "absolute",
    top: "4rem",
    right: "0.6rem",
    zIndex: 500,
    background: "white",
  },
}

const DialogDetailContentDetailView = (props) => {
  const scrollContainerRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [mapMode, setMapMode] = useState(MapMode.Map)
  const [openConfirmDeletePhoto, setOpenConfirmDeletePhoto] = useState()
  const { Delete } = UseApiManager()
  const {setRefreshTime} = useContext(RootDataContext)

  const onDeletePhoto = useCallback(path => {
    setOpenConfirmDeletePhoto(path)
  }, [])

  const onDeletePhotoSubmit = useCallback(() => {
    const path = openConfirmDeletePhoto
    setOpenConfirmDeletePhoto(null)
    setLoading(true)
    Delete("photo/tree", { tree_id: props.data.tree_id, path })
      .then(() => RefreshTree())
      .then(() => {
        setRefreshTime()
      })
      .finally(() => setLoading(false))
  }, [openConfirmDeletePhoto, props.data.tree_id])

  return (
    <Box style={styles.root}>
      <Box style={styles.leftColumn} ref={scrollContainerRef}>
        <Datatable
          data={props.data}
          sx={{ minWidth: "400px" }}
          onDeletePhoto={onDeletePhoto}
          scrollContainerRef={scrollContainerRef}
        />
      </Box>
      <Box style={styles.rightColumn}>
        {mapMode === MapMode.Map && <Map data={props.data} />}
        {mapMode === MapMode.StreetView && <StreetView data={props.data} />}
        <Box style={styles.mapModeBox}>
          <ButtonGroup>
            <IconButton
              onClick={() =>
                mapMode === MapMode.StreetView && setMapMode(MapMode.Map)
              }
            >
              <MapIcon
                style={{
                  color: mapMode === MapMode.Map ? "#9974ff" : "#c7c7c7",
                }}
              />
            </IconButton>
            <IconButton
              onClick={() =>
                mapMode === MapMode.Map && setMapMode(MapMode.StreetView)
              }
            >
              <BoyIcon
                style={{
                  color: mapMode === MapMode.StreetView ? "#9974ff" : "#c7c7c7",
                }}
              />
            </IconButton>
          </ButtonGroup>
        </Box>
      </Box>
      <Dialog open={!!openConfirmDeletePhoto}>
        <DialogTitle>この画像を削除しますか</DialogTitle>
        <DialogContent>
          <DialogContentText>この操作はもとに戻せません。本当に削除しますか</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDeletePhoto(null)}>キャンセル</Button>
          <Button color="secondary" onClick={onDeletePhotoSubmit}>削除</Button>
        </DialogActions>
      </Dialog>
      <Backdrop open={loading} style={{zIndex: 2000}}>
        <CircularProgress />
      </Backdrop>
    </Box>
  )
}

DialogDetailContentDetailView.propTypes = {
  className: PropTypes.string,
  data: PropTypes.any,
}

export default DialogDetailContentDetailView
